import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import API_URL, { IMAGE_URL } from "../config/config";
import "../css/productdetails.css";
import { useNavigate } from "react-router-dom";
import ProductCard from "../components/ProductCard";
function ProductDetails() {

  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [qty, setQty] = useState(1);
  const [relatedProducts, setRelatedProducts] = useState([]);
const navigate = useNavigate();
  useEffect(() => {
    axios
      .get(`${API_URL}/products/${id}`)
      .then((res) => {
        setProduct(res.data);
        axios
  .get(
    `${API_URL}/related-products/${res.data.category}/${res.data.id}`
  )
  .then((response) => {
    setRelatedProducts(response.data);
  })
  .catch((err) => console.log(err));
      })
      .catch((err) => console.log(err));
  }, [id]);

  if (!product) {
    return <h2 className="loading">Loading...</h2>;
  }


  const handleAddToCart = async () => {

  const user = JSON.parse(localStorage.getItem("user"));

  if (!user) {
    alert("Please login first.");
    navigate("/login");
    return;
  }

  try {

    await axios.post(`${API_URL}/cart`, {
      user_id: user.id,
      product_id: product.id,
      quantity: qty
    });

    alert("Product added to cart!");

  } catch (err) {

    console.log(err);
    alert("Unable to add product.");

  }

};
  return (
    <div className="product-details-container">

      <div className="product-left">

        <img
          src={`${IMAGE_URL}${product.image}`}
          alt={product.product_name}
          className="details-image"
        />

      </div>

      <div className="product-right">

        <h1>{product.product_name}</h1>

        <p className="rating">
          ⭐⭐⭐⭐⭐ (120 Reviews)
        </p>

        <p>
          <strong>Brand:</strong> {product.brand}
        </p>

        <p>
          <strong>Category:</strong> {product.category}
        </p>

        <h2 className="price">
          ${product.price}
        </h2>

        <p className="stock">
          {product.stock > 0
            ? `✅ In Stock (${product.stock})`
            : "❌ Out of Stock"}
        </p>

        <div className="quantity-box">

          <button
            onClick={() =>
              qty > 1 && setQty(qty - 1)
            }
          >
            -
          </button>

          <span>{qty}</span>

          <button
            onClick={() => setQty(qty + 1)}
          >
            +
          </button>

        </div>

        <button
  className="cart-btn"
  onClick={handleAddToCart}
>
  Add to Cart
</button>

        <button className="wishlist-btn2">
          Add to Wishlist
        </button>

      </div>
<section className="products-section">

  <h2 className="section-title">
    You May Also Like
  </h2>

  <div className="products-grid">

    {relatedProducts.map((item) => (

      <ProductCard
        key={item.id}
        product={item}
      />

    ))}

  </div>

</section>
    </div>
  );
}

export default ProductDetails;